// EventStepLeagueMatch.tsx
import React, { useEffect, useState } from 'react';
import { EventDataMap } from '../../../types/EventTypes';

interface Props {
  onNext: (data: EventDataMap['league']) => void;
  onBack: () => void;
  initialData?: EventDataMap['league'];
}

const EventStepLeagueMatch: React.FC<Props> = ({
  onNext,
  onBack,
  initialData,
}) => {
  const [formData, setFormData] = useState<EventDataMap['league']>({
    opponent: '',
    referee: {
      name: '',
      email: '',
      phone: '',
    },
    gameNumber: '',
    eventCode: '',
    eventPin: '',
  });

  useEffect(() => {
    if (initialData) {
      const safeRef = initialData.referee || { name: '', email: '', phone: '' };

      setFormData(prev => ({
        ...prev,
        ...initialData,
        referee: {
          name: safeRef.name,
          email: safeRef.email,
          phone: safeRef.phone,
        },
      }));
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name.startsWith('referee.')) {
      const field = name.split('.')[1];
      setFormData(prev => ({
        ...prev,
        referee: {
          ...prev.referee,
          [field]: value,
        },
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onNext(formData);
  };

  return (
    <form onSubmit={handleSubmit} className='space-y-4'>
      <h2 className='text-xl font-bold'>Step 2: League Match Info</h2>

      <label className='block'>
        <span className='text-sm font-medium'>Opponent</span>
        <input
          type='text'
          name='opponent'
          value={formData.opponent}
          onChange={handleChange}
          required
          className='p-2 border rounded w-full'
        />
      </label>

      <fieldset className='space-y-2'>
        <legend className='text-sm font-semibold'>Referee Details</legend>

        <input
          type='text'
          name='referee.name'
          placeholder='Full Name'
          value={formData.referee.name}
          onChange={handleChange}
          className='p-2 border rounded w-full'
        />

        <input
          type='email'
          name='referee.email'
          placeholder='Email Address'
          value={formData.referee.email}
          onChange={handleChange}
          className='p-2 border rounded w-full'
        />

        <input
          type='tel'
          name='referee.phone'
          placeholder='Mobile Number'
          value={formData.referee.phone}
          onChange={handleChange}
          className='p-2 border rounded w-full'
        />
      </fieldset>

      <label className='block'>
        <span className='text-sm font-medium'>Game Number</span>
        <input
          type='text'
          name='gameNumber'
          value={formData.gameNumber}
          onChange={handleChange}
          className='p-2 border rounded w-full'
        />
      </label>

      <label className='block'>
        <span className='text-sm font-medium'>Event Code</span>
        <input
          type='text'
          name='eventCode'
          value={formData.eventCode}
          onChange={handleChange}
          className='p-2 border rounded w-full'
        />
      </label>

      <label className='block'>
        <span className='text-sm font-medium'>Event Pin</span>
        <input
          type='text'
          name='eventPin'
          value={formData.eventPin}
          onChange={handleChange}
          className='p-2 border rounded w-full'
        />
      </label>

      <div className='flex justify-between'>
        <button
          type='button'
          onClick={onBack}
          className='px-4 py-2 bg-gray-400 text-white rounded'
        >
          Back
        </button>
        <button
          type='submit'
          className='px-4 py-2 bg-blue-600 text-white rounded'
        >
          Save
        </button>
      </div>
    </form>
  );
};

export default EventStepLeagueMatch;
